import { useEffect, useRef } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

/**
 * Iter 130.ad · Watcher de alertas fiscales en el SaaS.
 *
 * Carga el resumen de alertas fiscales al montar Layout y muestra un toast
 * (una sola vez por sesión y por estado) cuando hay obligaciones vencidas o
 * urgentes (≤7 días). Re-comprueba cada 30 minutos.
 */
export default function FiscalAlertWatcher() {
  const yaNotificado = useRef(new Set());

  useEffect(() => {
    let alive = true;
    let timer = null;

    const tick = async () => {
      try {
        const r = await api.get("/fiscal/sl/badge-count");
        if (!alive) return;
        const d = r.data;
        const sessionKey = "fiscal-alert-watcher-shown";
        const yaSesion = (() => {
          try { return JSON.parse(sessionStorage.getItem(sessionKey) || "{}"); }
          catch { return {}; }
        })();

        // Toast vencidos
        if (d.vencidos > 0 && !yaSesion.vencidos) {
          toast.error(`🛑 Tienes ${d.vencidos} obligación(es) fiscal(es) VENCIDAS · Revisa /fiscal-sl`, {
            duration: 10000,
            action: { label: "Ver", onClick: () => { window.location.href = "/fiscal-sl"; } },
          });
          yaSesion.vencidos = true;
        }
        // Toast urgentes
        if (d.urgentes_7d > 0 && !yaSesion.urgentes) {
          const top = d.top.filter((t) => t.severidad === "urgente").slice(0, 2);
          const descTop = top.length ? " · Próximas: " + top.map((t) => `${t.modelo} (${t.dias}d)`).join(", ") : "";
          toast.warning(`⚠️ ${d.urgentes_7d} obligación(es) fiscal(es) vencen en ≤7 días${descTop}`, {
            duration: 8000,
            action: { label: "Ver", onClick: () => { window.location.href = "/fiscal-sl"; } },
          });
          yaSesion.urgentes = true;
        }
        try { sessionStorage.setItem(sessionKey, JSON.stringify(yaSesion)); } catch {/* ignore */}
      } catch {/* ignore */}
    };

    tick();
    timer = setInterval(tick, 30 * 60 * 1000);
    return () => { alive = false; if (timer) clearInterval(timer); };
  }, []);

  return null;
}
